import React, { Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";

export function withLayout<P extends object>(
  Layout: React.ComponentType<any>,
  layoutProps: Record<string, any> = {},
  loading: () => React.ReactNode,
  redirectTo?: string,
  redirectReplace?: boolean
) {
  return function (WrappedComponent?: React.ComponentType<P>) {
    return function LayoutWrapper(props: P) {
      const location = useLocation();
      if (redirectTo) {
        return <Navigate to={redirectTo} replace={redirectReplace} />;
      }
      return (
        <Suspense fallback={loading()}>
          <Layout {...layoutProps} location={location}>
            <WrappedComponent {...props} />
          </Layout>
        </Suspense>
      );
    };
  };
}